export default __webpack_public_path__ + "static/media/circular-medium.c68dd443.woff";